import { memo, useEffect, useState } from 'react';
import { Button, CircularProgress, Grid } from '@mui/material';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';

import FormSwitchField from 'components/ui/form/FormSwitchField';
import useFormSubmit from 'hooks/useFormSubmit';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

const switchOptions = [
  { value: 1, checked: true },
  { value: 0, checked: false },
];

// Peniya jami summasini shartnoma ekranida ko'rsatish/ko'rsatmaslik sozlamasi.
// Har bir obyektning kunlik peniya foizi esa Sozlash → Obyektlar bo'limida.
const PenaltyTab = () => {
  const { t } = useTranslation();
  const axiosPrivate = useAxiosPrivate();
  const { submit, isSubmitting } = useFormSubmit();
  const [loading, setLoading] = useState(true);

  const formik = useFormik({
    initialValues: { show_on_contract: 1 },
    onSubmit: (values) => {
      submit(
        { type: 'post', contentType: 'simple' },
        { show_on_contract: values.show_on_contract ? 1 : 0 },
        '/admin/penalty-settings',
        { title: t('settings.penalty.saved') },
        null,
        true,
      );
    },
  });

  useEffect(() => {
    setLoading(true);
    axiosPrivate
      .get('/admin/penalty-settings')
      .then((response) => {
        const data = response?.data?.data;
        formik.setValues({ show_on_contract: data?.show_on_contract ? 1 : 0 });
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='p-4 max-w-md'>
      {loading ? (
        <div className='flex justify-center py-8'>
          <CircularProgress size={30} />
        </div>
      ) : (
        <form onSubmit={formik.handleSubmit}>
          <p className='text-sm text-gray-500 mb-3'>
            {t('settings.penalty.description')}
          </p>

          <Grid container spacing={2} rowSpacing={1} columns={{ xs: 12 }}>
            <Grid item xs={12}>
              <FormSwitchField
                delay={0}
                label={t('settings.penalty.showOnContract')}
                fieldName='show_on_contract'
                formik={formik}
                options={switchOptions}
              />
            </Grid>

            <Grid item xs={12}>
              <div className='flex justify-end pt-2'>
                <Button
                  variant='base'
                  color='success'
                  type='submit'
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <CircularProgress size={18} />
                  ) : (
                    t('common.button.save')
                  )}
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      )}
    </div>
  );
};

export default memo(PenaltyTab);
